<template>
    <div v-if="index !== null && itemCount" class="nopads ps-4 pb-2">
        <font-awesome-icon icon="arrow-left" class="arrow-icon px-1" :class="{ 'arrow-disabled': firstItem }"
                           @click.stop="previousClicked"/>
        <span class="px-1 counter-text">{{ index + 1 }} / {{ itemCount }}</span>
        <font-awesome-icon icon="arrow-right" class="arrow-icon px-1" :class="{ 'arrow-disabled': lastItem}"
                           @click.stop="nextClicked"/>
    </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'EditorItemBrowser',
    components: {FontAwesomeIcon},
    mixins: [],
    props: {
        index: {
            type: Number,
            default: null
        },
        itemCount: {
            type: Number,
            default: null
        }
    },
    emits: ['previousItem', 'nextItem'],
    data() {
        return {}
    },
    computed: {
        lastItem() {
            return this.index !== null && this.itemCount && this.index === this.itemCount - 1
        },
        firstItem() {
            return this.index === 0
        }
    },
    methods: {
        previousClicked() {
            if (!this.firstItem) this.$emit('previousItem')
        },
        nextClicked() {
            if (!this.lastItem) this.$emit('nextItem')
        }
    }
}
</script>
<style>
.arrow-icon {
    color: #0b4b8f;
    font-size: .9em;
    cursor: pointer;
}

.arrow-icon:hover {
    color: #007BFF;
    font-size: .9em;
}

.arrow-disabled, .arrow-disabled:hover {
    color: #d9d9d9;
    cursor: default;
}

.counter-text {
    color: #636364;
    font-size: .9em;
}
</style>
